import React, { useState } from "react";
import styled from "styled-components";
import sorticon from "../../../Images/Icons/sort.png"
import { DropDownSection, List, ListWrapper } from "./Styled";

const Root = styled.div``;
const Container = styled.div`
  position: relative;
`;

const SelecteWrapper = styled.div`
  display: flex;
`;
const Select = styled.select`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 16px;
  padding: 15px 10px;
  border: none;
  margin: 0 10px;
  outline: none;
  cursor: pointer;
  @media (max-width: 1440px) {
    padding: 12px 8px;
  }
`;
const Option = styled.option`
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 28px;
  background-color: #262A2D;
    color: white;
    cursor: pointer !important;
  :hover {
    padding: 10px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
  }
`;

const FilterShotContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;

const FliterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const FilterSelect = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 16px;
  padding: 15px 10px;
  border: none;
  margin: 0 10px;
  outline: none;
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  margin: 0 10px;
`;
const Image = styled.img`
width: 24px;
`;

const StyledSelect = styled.select`
  padding: 8px;
  padding-right: 32px;
  font-size: 14px;
  border: 1px solid #8A8AA0;
  border-radius: 4px;
  font-family: 'Lato', sans-serif;
  background-color: transparent;
  color: #8A8AA0;
  outline: none;
  appearance: none; /* Remove default arrow */
  background-image: url("data:image/svg+xml;charset=UTF-8,<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M4 6L8 10L12 6' stroke='%238A8AA0' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center; /* Position arrow with padding */
  background-size: 16px 16px;
  @media(max-width:1024px){
    width: 100%;
  }
`;



const CategoriesFilter = ({selectFilter, setSelectFilter,showMobileFilter,setShowMobileFilter,setShowSubCatFilter}) => {
  const [category, setCategory] = useState("All");
  const [subcategory, setSubcategory] = useState("All");
  const [type, setType] = useState("All");
  const [subcategories, setSubcategories] = useState([]);
  const [types, setTypes] = useState([]);
  const [filterState, setFilterState] = useState("");
  

  const changeCategory = (e) => {
    setCategory(e.target.value);
    setSubcategories(
      Categories.find((cat) => cat.name === e.target.value).subcategories
    );
  };

  const changeSubCat = (e) => {
    setSubcategory(e.target.value);
    setTypes(
      subcategories.find((subcategory) => subcategory.name === e.target.value)
        .types
    );
    // console.log(".......", subcategories);
  };


  

  return (
    <Root>
      <Container>
        {/* Desktop filter */}
        <StyledSelect
          style={{ display: window.innerWidth < 500 ? "none" : "block" }}
          onChange={(e) => {
            setSelectFilter(e.target.value);
          }}
          value={selectFilter}
        >
          <Option value="All">All</Option>
          <Option value="phtl">Price High to Low</Option>
          <Option value="plth">Price Low to High</Option>
          <Option value="latest">Latest</Option>
        </StyledSelect>

        {/* Mobile filter icon */}
        {window.innerWidth < 500 && (
          <ImageWrapper>
            <Image
              src={sorticon}
              alt="Filter"
              style={{ cursor: "pointer" }}
              onClick={() => {setShowMobileFilter(!showMobileFilter);setShowSubCatFilter(false)}}
            />
            {showMobileFilter && (
              <DropDownSection>
                <ListWrapper style={{ flexDirection: "column", alignItems: "flex-start" }}>
                  <List style={selectFilter=='All'?{color:"#25a8c5"}:{}} onClick={() => { setSelectFilter("All"); setShowMobileFilter(false); }}>All</List>
                  <List style={selectFilter=='phtl'?{color:"#25a8c5"}:{}} onClick={() => { setSelectFilter("phtl"); setShowMobileFilter(false); }}>Price High to Low</List>
                  <List style={selectFilter=='plth'?{color:"#25a8c5"}:{}} onClick={() => { setSelectFilter("plth"); setShowMobileFilter(false); }}>Price Low to High</List>
                  <List style={selectFilter=='latest'?{color:"#25a8c5"}:{}} onClick={() => { setSelectFilter("latest"); setShowMobileFilter(false); }}>Latest</List>
                </ListWrapper>
              </DropDownSection>
            )}
          </ImageWrapper>
        )}
      </Container>
    </Root>
  );
};

export default CategoriesFilter;
